"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { chakra, useMultiStyleConfig, forwardRef } from "@chakra-ui/react";
import { LogoColorModes, LogoSizes, LogoVariants, LogoVersions, } from "./Logo.types";
import { viewBoxSizes } from "./Logo.helpers";
import { logoSVG } from "./logoSVG";
const Logo = forwardRef((_a, ref) => {
    var { variant = LogoVariants.PRIMARY, size = LogoSizes.MEDIUM, colorMode = LogoColorModes.DARK, version = LogoVersions.COMPANY } = _a, rest = __rest(_a, ["variant", "size", "colorMode", "version"]);
    const styles = useMultiStyleConfig("Logo", { variant, size });
    const pathGenerator = useCallback(({ path, key, opts, }) => _jsx(chakra.path, Object.assign({ d: path }, opts), key), []);
    const { pluxee } = logoSVG[version];
    return (_jsx(chakra.svg, Object.assign({ ref: ref, width: "100%", height: "auto", viewBox: viewBoxSizes[version][size], fill: "none", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMin", sx: styles.container }, rest, { color: colorMode === "dark"
            ? "semantic.brand.primary"
            : "semantic.icon.inverse" }, { children: _jsx(chakra.g, Object.assign({ sx: styles.logo }, { children: pluxee.map(({ letter, path }, index) => {
                const key = `pluxee-${letter}-${index}`;
                const opts = letter === "x"
                    ? Object.assign(Object.assign({}, styles.symbol), (colorMode === "light" &&
                        variant === LogoVariants.PRIMARY
                        ? { fill: "currentColor" }
                        : {})) : { sx: styles.logoLetter, fill: "currentColor" };
                return pathGenerator({ path, key, opts });
            }) })) })));
});
Logo.displayName = "Logo";
export default Logo;
//# sourceMappingURL=Logo.js.map